import { usdMicrosFromCentsFallback } from '../components/formatters.ts';

/**
 * Ledger money as a CNY *yuan* number for Excel (#178).
 *
 * The UI formats this as a string; the spreadsheet needs a number so
 * SUM/filter work. Micros are authoritative; cents are the pre-cutover
 * fallback. A missing or invalid display rate must not write a USD
 * number into a 「元」 column — callers abort the export instead.
 */
export function moneyYuan(
  usdMicros: number | null | undefined,
  usdCents: number | null | undefined,
  cnyPerUsd: number | null,
): number {
  const micros = usdMicrosFromCentsFallback(usdMicros, usdCents);
  return (micros * requireExportRate(cnyPerUsd)) / 1_000_000;
}

/** USD cents → yuan number. `null` cents stay `null` (no fabricated 0). */
export function centsToYuan(
  usdCents: number | null | undefined,
  cnyPerUsd: number | null,
): number | null {
  if (typeof usdCents !== 'number' || !Number.isFinite(usdCents)) {
    return null;
  }
  return (usdCents * requireExportRate(cnyPerUsd)) / 100;
}

/** Same predicate the on-screen CNY formatters use before showing 「—」. */
export function isValidExportRate(cnyPerUsd: number | null | undefined): cnyPerUsd is number {
  return typeof cnyPerUsd === 'number' && Number.isFinite(cnyPerUsd) && cnyPerUsd > 0;
}

function requireExportRate(cnyPerUsd: number | null): number {
  if (!isValidExportRate(cnyPerUsd)) {
    throw new Error('export display rate unavailable');
  }
  return cnyPerUsd;
}
